(function () {
  function boot() {
    document.querySelectorAll('.hdy-ring-size-help summary').forEach(function (summary) {
      if (summary.dataset.hadayaSizeKeyboard) return;
      summary.dataset.hadayaSizeKeyboard = 'true';
      // App form keypress handlers must not submit when the customer opens sizing help.
      summary.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        summary.parentElement.open = !summary.parentElement.open;
      }, true);
      summary.addEventListener('keyup', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
